import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { LOGOS } from '../constants/assets';

const QUOTES = [
  {
    text: "Finding my dream role at RM Ghana was the turning point of my career. The growth opportunities here are truly unmatched.",
    author: "Kofi Mensah"
  },
  {
    text: "The work-life balance and supportive culture made me fall in love with my job again. I've never felt more valued as a professional.",
    author: "Abena Appiah"
  },
  {
    text: "RM Ghana doesn't just offer jobs; they build careers. My transition into a leadership role was seamless thanks to their mentorship.",
    author: "Samuel Boateng"
  }
];

const AuthLayout = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % QUOTES.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="min-h-screen flex flex-col justify-center items-center relative overflow-hidden bg-gradient-to-br from-[#12b8a6] via-[#2469a5] to-[#2e316e] p-4 sm:p-8">
      <div className="absolute inset-0 z-0 opacity-20 pointer-events-none" style={{ backgroundImage: 'radial-gradient(circle, #ffffff 1px, transparent 1px)', backgroundSize: '24px 24px' }}></div>
      
      <div className="z-10 w-full max-w-[1000px] flex flex-col lg:flex-row rounded-lg lg:rounded-2xl shadow-2xl overflow-hidden bg-white min-h-[600px]">
        
        <div className="hidden lg:flex flex-col w-1/2 relative bg-cover bg-center" style={{ backgroundImage: 'url("https://media-manager-c.questera.ai/greta-media/3140d8d6cb9117fc579edbc74f55e47991f06b3358b3a2dbff9e876f24bde08089c96c4a7bef32e6eede9d743c938dc3/images/aW1hZ2Uvd2VicA==/a919a19e0b1567cd7c00b248c15f2df5.webp")' }}>
          <div className="absolute inset-0 bg-[#11469A]/85"></div>
          
          <div className="relative z-10 p-12 flex flex-col h-full justify-between">
            <div>
              <img src={LOGOS.main} alt="RM Ghana logo" className="h-10 max-w-[220px] object-contain brightness-0 invert" />
            </div>
            
            <div className="text-center px-4 relative h-48 flex flex-col justify-center">
              <div className="text-[#00AEEF] text-7xl font-serif font-bold leading-none mb-2 opacity-50 absolute top-0 left-1/2 -translate-x-1/2">“</div>
              <div className="relative h-28 mt-8">
                <AnimatePresence mode="wait">
                  <motion.div
                    key={currentSlide}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.5 }}
                    className="absolute inset-0 flex flex-col items-center"
                  >
                    <p className="text-white text-lg font-medium italic leading-relaxed mb-4">"{QUOTES[currentSlide].text}"</p>
                    <div className="text-white/80 text-sm font-semibold tracking-wider uppercase">- {QUOTES[currentSlide].author}</div>
                  </motion.div>
                </AnimatePresence>
              </div>
            </div>

            <div className="flex justify-center gap-2.5">
              {QUOTES.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setCurrentSlide(idx)}
                  className={`h-1.5 rounded-full transition-all duration-300 ${currentSlide === idx ? 'w-8 bg-white' : 'w-4 bg-white/30 hover:bg-white/50'}`}
                />
              ))}
            </div>
          </div>
        </div>

        <div className="w-full lg:w-1/2 p-8 sm:p-12 lg:p-16 flex flex-col justify-center bg-white relative">
          <Outlet />
        </div>
        
      </div>

      <div className="z-10 mt-8 text-white/70 text-sm font-medium text-center">
        ©2026 RM Ghana. All rights reserved. | Powered by Resource And Manpower
      </div>
    </div>
  );
};

export default AuthLayout;